export enum ScreenEnum {
  'home' = '/youtube-reload',
  'likes' = '/youtube-reload/likes',
  'unLikes' = '/youtube-reload/unLikes',
}
